import { useTranslation } from '../../hooks/useTranslation'
import Tooltip from '../base/Tooltip'
import { removeDuplicateLocation } from './index.utils'

export const MultipleLocationLatLngView = ({ jobLocations = [] }) => {
  const { translate } = useTranslation()
  const removeDuplicate = removeDuplicateLocation(jobLocations, false)

  return (
    <>
      {removeDuplicate.length !== 0 ? (
        <ul>
          {removeDuplicate.map((location, index) => (
            <li key={`list-location-lat-lng-${index}`}>
              {location?.attributes?.address}
              {location?.attributes?.address ? (
                <a
                  style={{ marginLeft: 8 }}
                  className="view-map"
                  rel="noreferrer"
                  target="_blank"
                  href={`https://maps.google.com/maps?q=${encodeURIComponent(location?.attributes?.address)}&t=&z=13&ie=UTF8 `}>
                  {translate('page_jobs:view_map')}
                </a>
              ) : null}
            </li>
          ))}
        </ul>
      ) : null}
    </>
  )
}

const MultipleLocationView = ({ jobLocations = [], otherTranslate = '', placement = '' }) => {
  const { currentLanguage, translate } = useTranslation()
  const removeDuplicate = removeDuplicateLocation(jobLocations, true)

  return (
    <>
      {removeDuplicate.length ? (
        <div className="location">
          {removeDuplicate.length < 2 ? (
            <span>
              {currentLanguage === 'en'
                ? removeDuplicate[0]?.attributes?.location?.data?.attributes?.state
                : removeDuplicate[0]?.attributes?.location?.data?.attributes?.state_vn}
            </span>
          ) : (
            <Tooltip
              placement={placement}
              title={removeDuplicate
                .map(
                  (session) =>
                    (currentLanguage === 'en'
                      ? session?.attributes?.location?.data?.attributes?.state
                      : session?.attributes?.location?.data?.attributes?.state_vn) || ''
                )
                .join(', ')}>
              {`${
                currentLanguage === 'en'
                  ? removeDuplicate[0]?.attributes?.location?.data?.attributes?.state
                  : removeDuplicate[0]?.attributes?.location?.data?.attributes?.state_vn
              } ${
                removeDuplicate.length >= 2 ? `& ${removeDuplicate.length - 1} ${otherTranslate || translate('label:other_place')}` : ''
              }`}
            </Tooltip>
          )}
        </div>
      ) : null}
    </>
  )
}

export default MultipleLocationView
